<template>
  <v-app>
    <div
      class="d-flex flex-column justify-center align-center fill-height mv-w-full"
    >
      <v-img max-height="100" max-width="100" :src="logo"> </v-img>
      <v-progress-circular
        class="mt-4"
        :size="24"
        color="blue"
        indeterminate
      ></v-progress-circular>
      <p class="mt-4 text-sm">{{ $i18n.t("login.title_welcome") }}</p>
    </div>
  </v-app>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import { userKeys, wdConfigData } from "@/service/wd_app_config.js";
import { i18n } from "@i18n";
import { api_get_palns } from "../subscriotion/services/subscriptionApi.js";

//例如: import <组件名称> from  <组建路径>
export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      logo: require("@/assets/logo.png"),
      products: [],
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    launch() {
      localStorage.setItem("welcome_action", null);
      localStorage.setItem("welcome_id", null);
      var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
      var accessToken = localStorage.getItem(userKeys.key_globalAccessToken);
      if (user != null && accessToken != null && accessToken.length > 0) {
        // already logged in, decide where to go based on link parameters
        const action = this.$route.query.action;
        const id = this.$route.query.id;

        if (action && id) {
          localStorage.setItem("welcome_action", action);
          localStorage.setItem("welcome_id", id);

          if (action == "product") {
            // if localStorage has no productList, productList length is 0, then need to call api to get product data, and then redirect
            const productList = JSON.parse(localStorage.getItem("productList") || "[]");
            // if no productList in localStorage, need to call api to get product data
            if (productList.length == 0) {
              this.loadProducts(id);
            } else {
              const product = productList.find(p => p.Id == id);
              if (product) {
                this.$router.push({
                  name: 'checkout',
                  params: { product: product }
                });
              } else {
                this.$message.warning('No corresponding product subscription found. Please go to the product subscription page to confirm your purchase.');
                // subscriptions?tab=buy-subscriptions
                this.$router.push('/subscriptions?tab=buy-subscriptions');
              }
            }
          } else {
            this.$router.push('/subscriptions?tab=buy-subscriptions');
          }
        } else {
          this.$router.push('/subscriptions?tab=buy-subscriptions');
        }
      } else {
        // hasn't logged in, first go to login page, also need to check if the link carries parameters for redirection after login
        const action = this.$route.query.action;
        const id = this.$route.query.id;

        if (action && id) {
          localStorage.setItem("welcome_action", action);
          localStorage.setItem("welcome_id", id);
        }

        if (localStorage.getItem(userKeys.key_welcome_Remember)) {
          this.$router.replace("/welcome");
        } else {
          this.$router.replace("/welcome");
        }
      }
    },
    loadProducts(id) {
      try {
        var that = this;
        api_get_palns().then(
            (response) => {
              that.handleGetPlansResponse(response, id);
            },
            (error) => {
              console.error(error);
              this.$router.push('/subscriptions?tab=buy-subscriptions');
            }
        );
      } catch (error) {
        console.error('Failed to load products:', error);
        this.$router.push('/subscriptions?tab=buy-subscriptions');
      }
    },
    handleGetPlansResponse(response, id) {
      if (response.data.Code === 0) {
        this.products = response.data.Result.Plans.sort((a, b) => {
          const nameA = a.Name.toLowerCase();
          const nameB = b.Name.toLowerCase();

          // 判断是否包含 Plus / Pro
          const isPlusA = nameA.includes("plus");
          const isPlusB = nameB.includes("plus");
          const isProA  = nameA.includes("pro");
          const isProB  = nameB.includes("pro");

          // 赋值排序权重 (0 无 Plus/Pro, 1 Plus, 2 Pro)
          const weightA = isPlusA ? 1 : isProA ? 2 : 0;
          const weightB = isPlusB ? 1 : isProB ? 2 : 0;

          // 先按权重排：无 > Plus > Pro
          if (weightA !== weightB) {
            return weightA - weightB;
          }
          // 同类情况下按 Priority 从小到大
          return a.Priority - b.Priority;
        });
        for (let i = 0; i < this.products.length; i++) {
          this.products[i].Description = this.splitStringToArray(this.products[i].Description);
        }
        localStorage.setItem('productList', JSON.stringify(this.products ? this.products : []));

        const product = this.products.find(p => p.Id == id);
        this.$router.push({
          name: 'checkout',
          params: { product: product }
        });
      } else {
        console.error('Failed to get plans:', response.message);
        this.$router.push('/subscriptions?tab=buy-subscriptions');
      }
    },
    splitStringToArray(str) {
      if (!str) return [];
      const separator = str.includes('，') ? '，' : ', ';
      
      return str
        .split(separator)
        .map(item => item.trim())
        .filter(item => item !== '');
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {
    var that = this;
    setTimeout(() => {
      that.launch();
    }, 1000);
  },
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    i18n.locale = wdConfigData.localLanguage
  },
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss"></style>
